import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "@phosphor-icons/react";
import { useContent, pick } from "../../lib/content";

export default function CTABand({ phone }) {
  const c = useContent();
  return (
    <section className="bg-atc-red text-white relative overflow-hidden" data-testid="cta-band">
      <div className="absolute inset-0 bg-blueprint-grid-dark bg-[size:3rem_3rem] opacity-20" />
      <div className="container-max relative py-20 grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-8">
          <div className="overline text-white/80 mb-4">{pick(c, "cta_band.overline", "Ready when you are")}</div>
          <h2 className="h-section text-white">
            {pick(c, "cta_band.title_line_1", "Schedule your")}<br/>
            {pick(c, "cta_band.title_line_2", "free estimate today")}
          </h2>
          <p className="mt-5 text-white/80 max-w-xl">{pick(c, "cta_band.body", "")}</p>
        </div>
        <div className="md:col-span-4 flex flex-col gap-3">
          {phone && (
            <a href={`tel:${phone}`} className="btn-ghost-white w-full" data-testid="cta-phone">
              <Phone size={18} weight="bold" /> {pick(c, "cta_band.call_button_prefix", "Call")} {phone}
            </a>
          )}
          <Link to="/contact" className="inline-flex items-center justify-center gap-2 bg-white text-atc-red px-6 py-3 font-heading uppercase tracking-widest text-sm font-bold border-2 border-white hover:bg-atc-black hover:border-atc-black hover:text-white transition-all" data-testid="cta-contact">
            {pick(c, "cta_band.quote_button", "Request a Quote")} <ArrowRight size={18} weight="bold" />
          </Link>
        </div>
      </div>
    </section>
  );
}
